const FluxConstant = require('flux-constant');


module.exports = FluxConstant.set([
    'REGISTER',
    'REGISTER_RESPONSE'
]);



// WEBPACK FOOTER //
// client/pages/main/signup/constants.js